import React, { useState } from 'react';
import { Box, Button, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { WSIcons } from '../../commonFunctions/iIcons';

export const Login: React.FC<any> =React.memo ((props) => {
  const [pin, setPin] = useState('');

  const handlePinClick = (value: string) => {
    setPin((prevPin) => prevPin + value);
  };

  const handleClear = () => {
    setPin('');
  };
  const handleBackspace = () => {
    setPin((prevPin) => prevPin.slice(0, -1));
  };
  return (
    <Grid
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#1de9b6',
      }}
    >
      <Grid
        sx={{
          backgroundColor: '#ffffff',
          padding: '32px',
          borderRadius: '8px',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
          width: '300px',
        }}
      >
        <Typography variant="h5" component="h2" align="center" gutterBottom>
          eZee Optimus
        </Typography>
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: 3,
          }}
        >
          <IconButton aria-label="lock">
            <WSIcons.LockIcon fontSize="large" />
          </IconButton>

          {/* Mode Switch Button with Label */}
          <Grid sx={{ display: 'flex', alignItems: 'center', ml: 2 }}>
      <Tooltip
        title={
          <Typography sx={{ color: 'red', fontWeight: 'bold' }}>
            Pin Mode
          </Typography>
        }
        arrow
        placement="right"  
        
      >
        <IconButton
          aria-label="pin mode"
          color="primary"
          sx={{
            padding: 1.5,
            borderRadius: 2,
          }}
        >
          <WSIcons.DialpadIcon />
        </IconButton>
      </Tooltip>
    </Grid>
        </Grid>

        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '16px',
          }}
        >
          {[...Array(4)].map((_, index) => (
            <Box
              key={index}
              sx={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                backgroundColor: pin.length > index ? '#1de9b6' : '#e0e0e0',
                margin: '0 8px',
              }}
            />
          ))}
        </Grid>

        <Grid
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)', // 3 columns
            gap: '8px',
          }}
        >
          {[7, 8, 9, 4, 5, 6, 1, 2, 3].map((number) => (
            <Button
              key={number}
              onClick={() => handlePinClick(number.toString())}
              sx={{
                backgroundColor: '#f0f0f0',
                color: '#333333',
                height: '64px',
                fontSize: '20px',
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: '#e0e0e0',
                },
              }}
            >
              {number}
            </Button>
          ))}

          {/* Clear, Zero, Backspace */}
          <Button
            onClick={handleClear}
            sx={{
              backgroundColor: '#f0f0f0',
              color: '#333333',
              height: '64px',
              fontSize: '20px',
              fontWeight: 'bold',
              '&:hover': {
                backgroundColor: '#e0e0e0',
              },
            }}
          >
            C
          </Button>

          <Button
            onClick={() => handlePinClick('0')}
            sx={{
              backgroundColor: '#f0f0f0',
              color: '#333333',
              height: '64px',
              fontSize: '20px',
              fontWeight: 'bold',
              '&:hover': {
                backgroundColor: '#e0e0e0',
              },
            }}
          >
            0
          </Button>

          <Button
            onClick={handleBackspace}
            sx={{
              backgroundColor: '#f0f0f0',
              color: '#333333',
              height: '64px',
              fontSize: '20px',
              fontWeight: 'bold',
              '&:hover': {
                backgroundColor: '#e0e0e0',
              },
            }}
          >
            <WSIcons.BackspaceIcon />
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
});

